import React, { FC, useState } from "react";
import { usePurchasePoDetailsModel } from "./purchasePoDetailsModel";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { YHDrawer } from "@/components/YhDrawer";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";

export const WhConfirmDrawer: FC<RouterParamType> = ({ id, mode }) => {
    const { wsConfirmModal: visible, detailDataSource, detailLookList, detailEditForm, setWsConfirmModal, warehousing, getDetailEditOne } = usePurchasePoDetailsModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [bcLoading, setBcLoading] = useState<boolean>(false)
    const onCancel = () => {
        setWsConfirmModal(false);
    };

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            dataIndex: "index",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        },
        {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '入库数量',
            width: 160,
            dataIndex: 'num',
        }
    ];

    const onSubmit = async () => {
        if (!bcLoading) {
            setBcLoading(true)
            let retData = await warehousing()
            if (retData) {
                setBcLoading(false)
                await onCancel();
                await getDetailEditOne(id, mode);
                await globalPrompt("message", { text: "入库成功", type: "success" });

            } else {
                setBcLoading(false)
                await onCancel()
                await globalPrompt("message", { text: "入库失败", type: "error" });
            }
        }
    }
    return (
        <YHDrawer
            {...{
                title: '库房确认',
                visible,
                onCancel,
                width: 800,
                okText: bcLoading ? '保存中' : "保存",
                onOk: debounce(() => { onSubmit() }, 900),
                // onOk: onSubmit,
                showFooter: mode === "look" ? false : true
            }}
        >
            <Table
                bordered
                // size="small"
                rowKey={record => record.id}
                columns={columns}
                dataSource={mode == "edit" ? detailDataSource : detailLookList}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YHDrawer>
    )
}